import EcomProject from "../assets/ecommerceLink.webp";
import FitnessProject from "../assets/FitnessApp.webp";
import GoogleProject from "../assets/googleCloneLink.webp";
import NetflixProject from "../assets/netflix.webp";
import RentCarsProject from "../assets/RentCars.webp";
import FoodifyProject from "../assets/foodify.webp";

export const projectsData = [
  {
    id: 1,
    image: GoogleProject,
    title: "Google Clone",
    description:
      "I have developed a personal rendition of a search engine resembling Google. This search engine is designed to retrieve search results based on the user's input, mimicking the functionality of the original Google search engine.",
    languages: ["React", "Google API"],
    link: "https://master--charming-capybara-2f2862.netlify.app/",
    githubLink: "https://github.com/FirdeusGj/Firdeus-Google-Clone",
  },
  {
    id: 2,
    image: NetflixProject,
    title: "Netflix Clone 2.0",
    description:
      "This represents a second iteration of a Netflix clone, offering a slightly akin functionality to Netflix itself. It facilitates movie search capabilities and furnishes comprehensive movie details upon request.",
    languages: ["Redux", "API"],
    link: "https://master--coruscating-cobbler-a84201.netlify.app/",
    githubLink: "https://github.com/FirdeusGj/NetflixClone",
  },
  {
    id: 3,
    image: FitnessProject,
    title: "Fitness App",
    description:
      "This website represents a fitness application designed to be affiliated with a gym. It offers various fitness plans that can be accessed through monthly subscription services. Furthermore, the website showcases testimonials from satisfied users and utilizes captivating animations to enhance the user experience.",
    languages: ["React"],
    link: "https://comfy-genie-738686.netlify.app/",
    githubLink: "https://github.com/FirdeusGj/Fitness-Website",
  },
  {
    id: 4,
    image: RentCarsProject,
    title: "Rent Cars",
    description:
      "This project presents a display of available rental cars, accompanied by their respective daily rates and models. It incorporates filters for refining selections based on the manufacturing year and fuel type of the vehicles.",
    languages: ["Next.js", "Tailwind", "TypeScript"],
    link: "https://rentagoodcar.netlify.app/",
    githubLink: "https://github.com/FirdeusGj/CarSales",
  },
  {
    id: 5,
    image: EcomProject,
    title: "Ecommerce App",
    description:
      "The website in question offers a wide selection of books for purchase, accompanied by advantageous pricing. Additionally, users have the ability to add books to their shopping cart. Furthermore, the website incorporates a filtering feature that enables sorting of books based on price, ranging from the highest to the lowest, as an illustrative example.",
    languages: ["React"],
    link: "https://imaginative-capybara-188b0a.netlify.app/",
    githubLink: "https://github.com/FirdeusGj/Library-react",
  },
  {
    id: 6,
    image: FoodifyProject,
    title: "Foodify",
    description:
      "Foodify is an application designed to display a variety of food categories, each containing a selection of recipes. When a category is clicked, relevant recipes are presented. Additionally, the app features a search functionality, enabling users to explore diverse food options.",
    languages: ["React", "API"],
    link: "https://foodifyrecipe.netlify.app/",
    githubLink: "https://github.com/FirdeusGj/Food-Recipe-App",
  },
];
